import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import useToken, { getTokenInfo } from '../../UseToken';
import { reqGET, reqPOST, reqPUT } from '../../Utils';
import Hosts from '../../Hosts';

import { language } from '../WEBContent/Language';
import { icon } from '../WEBContent/Icon';

const Notificacoes = ({ tarefas, entidadeLogada, props }) => {

    const prevEstadosRef = useRef([]);

    const [showNotifications, setShowNotifications] = useState(false);
    const [newNotification, setNewNotification] = useState([]);
    const [dismissedTarefaIds, setDismissedTarefaIds] = useState(new Set());
    const [highlightBell, setHighlightBell] = useState(false);
    const [alerts, setAlerts] = useState([]);

    const [lang, set_lang] = useState('pt');
  
    useEffect(() => {
        if (!tarefas || tarefas.length === 0) return;

        const changedTarefas = [];

        tarefas.forEach(tarefa => {
            const id = tarefa.id;
            const estadoAtual = tarefa.info.estado.labelPt || tarefa.info.estado.labelEn;
            const estadoAnterior = prevEstadosRef.current[id];

            if (estadoAnterior !== undefined && estadoAtual !== estadoAnterior) {
                changedTarefas.push(tarefa);
            }

            // Always update the current estado
            prevEstadosRef.current[id] = estadoAtual;
        });

        if (changedTarefas.length > 0) {
            setHighlightBell(true);

            changedTarefas.forEach(tarefa => {
                showAlert(`Mudança de estado: ${tarefa.info.name}`);
            });

            setNewNotification(prev => {
                const existingIds = new Set(prev.map(t => t.id));
                const novas = changedTarefas.filter(t => !existingIds.has(t.id));
                return [...prev, ...novas];
            });

            /*
            const interval = setInterval(() => {
                setHighlightBell(prev => !prev);
            }, 3600000);
            */

            return;
        }

    }, [tarefas]);

    useEffect(() => {
        setNewNotification(tarefas);
    }, [tarefas]);

    const showAlert = (message) => {
        const id = Date.now();
        setAlerts(prev => [...prev, { id, message }]);
        setTimeout(() => {
            setAlerts(prev => prev.filter(alert => alert.id !== id));
        }, 5000);
    };

    const toggleNotifications = () => {
        setShowNotifications(!showNotifications);
        setHighlightBell(false);
    };

    const handleTarefaClick = (tarefa) => {
        if (!entidadeLogada || !entidadeLogada.info) {
            console.error("Erro: 'entidadeLogada' ou 'entidadeLogada.info' não estão definidos.");
            return;
        }

        setNewNotification(newNotification.filter(t => t.id !== tarefa.id));

        setDismissedTarefaIds(prev => {
            const updated = new Set(prev).add(tarefa.id);
            showAlert(`Redirecionar para ${tarefa.info.name}`);
            return updated;
        });

        const dataAtual = new Date().toISOString();
        const lastUpdated = new Date().toISOString().split('T')[0];

        const tarefasExistentes = entidadeLogada.info.notify?.tarefas || [];
        const updatedTarefas = tarefasExistentes.includes(tarefa.id)
            ? tarefasExistentes
            : [...tarefasExistentes, tarefa.id];

        const updatedNotify = {
            dataAtual: dataAtual,
            tarefas: updatedTarefas,
            lastUpdated: lastUpdated
        };

        entidadeLogada.info.notify = updatedNotify;

        reqPUT(`${Hosts.SIMCore_API}/entities/`, entidadeLogada)
            .then(response => {
                console.log("Notificação atualizada com sucesso:", response);
            })
            .catch(error => {
                console.error("Erro ao atualizar notificação:", error);
            });
    };

    useEffect(() => {
        set_lang(localStorage.getItem('lang'))
    }, [props])

    return (
        <div style={{ position: 'relative', display: 'inline-block' }}>
            {/* Animation styles */}
            <style>
                {`
          @keyframes fadeInOut {
            0% { opacity: 0; transform: translateY(-10px); }
            10% { opacity: 1; transform: translateY(0); }
            90% { opacity: 1; transform: translateY(0); }
            100% { opacity: 0; transform: translateY(-10px); }
          }

          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
          }
        `}
            </style>

            {/* Bell Button */}
            <button
                onClick={toggleNotifications}
                style={{
                    background: 'none',
                    border: 'none',
                    position: 'relative',
                    padding: '5px',
                    color: highlightBell ? 'red' : 'inherit',
                    transition: 'color 0.5s ease-in-out',
                    cursor: 'pointer',
                    minWidth: '32px',
                    minHeight: '32px'
                }}
                aria-label="Notifications"
            >
                <i className={icon.bell.className} style={icon.bell.style}></i>

                {newNotification.length > 0 && (
                    <span
                        style={{
                            position: 'absolute',
                            top: '-5px',
                            right: '-5px',
                            background: 'red',
                            color: 'white',
                            borderRadius: '50%',
                            padding: '2px 6px',
                            fontSize: '0.8rem',
                            animation: 'pulse 1.5s infinite'
                        }}
                    >
                        {newNotification.length}
                    </span>
                )}
            </button>

            {/* Notifications Dropdown */}
            {showNotifications && (
                <div
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: '100%',
                        background: 'white',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                        minWidth: '200px',
                        marginTop: '5px',
                        zIndex: 1000
                    }}
                >
                    <div
                        style={{
                            padding: '10px',
                            borderBottom: '1px solid #eee',
                            fontWeight: 'bold'
                        }}
                    >
                        {language[lang].notifications}
                    </div>
                    <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                        {newNotification.length === 0 ? (
                            <div style={{ padding: '10px', color: '#666' }}>
                                {language[lang].notifications_empty}
                            </div>
                        ) : (
                            newNotification.map(tarefa => (
                                <div
                                    key={tarefa.id}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '10px',
                                        borderBottom: '1px solid #eee',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => handleTarefaClick(tarefa)}
                                >
                                    <div style={{ marginRight: '10px', fontSize: '18px', color: '#f0ad4e' }}>
                                        <i className={icon.info.className} style={icon.info.style}></i>
                                    </div>
                                    <Link
                                        to={{
                                            pathname: '/tarefa_view',
                                            state: { item: tarefa, operation: 'view' }
                                        }}
                                        style={{ textDecoration: 'none', color: '#333', flex: 1 }}
                                    >
                                        <div>
                                            <div style={{ fontWeight: 'bold' }}>{tarefa.info.name}</div>
                                            <div style={{ color: '#666', fontSize: '0.9em' }}>
                                                {lang === 'pt' ? tarefa.info.estado.labelPt : tarefa.info.estado.labelEn}
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}

            {/* Alerts */}
            <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 1050 }}>
                {alerts.map(alert => (
                    <div
                        key={alert.id}
                        style={{
                            background: 'red',
                            color: 'white',
                            padding: '10px',
                            marginBottom: '10px',
                            borderRadius: '5px',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.3)',
                            animation: 'fadeInOut 5s ease-in-out'
                        }}
                    >
                        <span>{alert.message}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Notificacoes;
